export default "__VITE_ASSET__CqvmaNWY__"